module.exports = __webpack_public_path__ + "static/media/localeth.76e57817.png";